var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntelligentCallRouting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.783,
    height: 139.176,
    viewBox: "0 0 76.783 139.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Intelligent_Call_Routing",
    "data-name": "Intelligent Call Routing",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_006---Merging-Lanes-Arrow",
    "data-name": "006---Merging-Lanes-Arrow",
    transform: "translate(0 -0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2.4,140.173H26.394a2.4,2.4,0,0,0,2.4-2.4V128.23a45.679,45.679,0,0,1,8.47-26.5l1.128-1.584,1.159,1.628a45.509,45.509,0,0,1,8.438,26.4v9.6a2.4,2.4,0,0,0,2.4,2.4H74.384a2.4,2.4,0,0,0,2.4-2.4v-9.6A73.661,73.661,0,0,0,62.938,85.009l-1.68-2.375a45.189,45.189,0,0,1-8.47-26.442v-9.6h14.4a2.367,2.367,0,0,0,1.944-3.743L40.407,1.987a2.4,2.4,0,0,0-3.887,0L7.654,42.85A2.367,2.367,0,0,0,9.6,46.593h14.4V56.2a45.482,45.482,0,0,1-8.47,26.434l-1.68,2.351A74.341,74.341,0,0,0,0,128.192v9.582a2.4,2.4,0,0,0,2.4,2.4Z",
    transform: "translate(0 -0.997)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentCallRouting);
export default __webpack_public_path__ + "static/media/Intelligent Call Routing.54538774ae674ab4893c7279996a2a1b.svg";
export { ForwardRef as ReactComponent };